import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserLeaveHistory } from './firebase';
import { STATUS_FETCHING, STATUS_ERROR, STATUS_READY, STATUS_IDLE } from './constants';

export const fetchUserLeaveHistory = createAsyncThunk(
  'getUserLeaveHistory',
  async (nip) => await getUserLeaveHistory(nip)
);

const userLeaveHistorySlice = createSlice({
  name: 'userLeaveHistory',
  initialState: {
    status: STATUS_IDLE,
    data: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchUserLeaveHistory.pending, (state, action) => {
        state.status = STATUS_FETCHING;
      })
      .addCase(fetchUserLeaveHistory.fulfilled, (state, action) => {
        state.status = STATUS_READY;
        state.data = action.payload;
      })
      .addCase(fetchUserLeaveHistory.rejected, (state, action) => {
        state.status = STATUS_ERROR;
        state.error = action.error.message;
      });
  },
});

export default userLeaveHistorySlice.reducer;
